module.exports = __webpack_public_path__ + "img/image117.39e50c51.jpg";